import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReportViewComponent } from './report-view/report-view.component';
import { ReportsComponent } from './reports.component';


const routes: Routes = [{
  path: 'reportview',
  component: ReportViewComponent,
}, {
  path: '',
  component: ReportsComponent,
}
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportsRoutingModule { }
